import * as constants from '../constants/constants';

export const loaderStart = () => {
  return {
    type: constants.LOADER_START,
  };
};

export const loaderFinish = () => {
  return {
    type: constants.LOADER_FINISH,
  };
};



// WEBPACK FOOTER //
// ./src/actions/loader.js